/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";
import {
  fetchContactDeal,
  fetchContactDetail,
  // fetchContactEmailList,
  // fetchContactNotesList,
  // fetchContactRevertEmail,
  // fetchContactSmsList,
  // fetchContactTasksList,
  fetchContactfeedList,
} from "../_redux/contact/contactAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { AddAttachment } from "../canvas/AddAttachment";
import { ContactDetailTop } from "../components/ContactDetailTop";
import { ContactTabs } from "../components/ContactTabs";
import { ContactUsers } from "../components/ContactUsers";
import { CreateContactOffCanvas } from "../canvas/CreateContactOffCanvas";
import DealsTable from "../Table/DealTable";
import { initIds } from "../../../../_metronic/_partials/controls/RightPanel";
import { useParams } from "react-router";
import { useSubheader } from "../../../../_metronic/layout";

export const ContactDetails = (props) => {
  const { setTitle } = useSubheader();
  useEffect(() => {
    setTitle("Contact Details");
  }, [setTitle]);

  const dispatch = useDispatch();
  const params = useParams();

  const [activeTab, setActiveTab] = useState("feeds");
  const [openCanva, setOpenCanva] = useState(false);

  const {
    contactDetail,
    notesList,
    tasksList,
    emailList,
    smsList,
    feedList,
    dealList,
    revertEmail,
    permission,
  } = useSelector(
    (state) => ({
      contactDetail: state.contact.detail,
      notesList: state.contact.notesList,
      tasksList: state.contact.tasksList,
      emailList: state.contact.emailList,
      smsList: state.contact.smsList,
      feedList: state.contact.feedList,
      dealList: state.contact.dealList,
      revertEmail: state.contact.revertEmail,
      permission: state.auth.permission,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (params?.id || props.ids) {
      dispatch(fetchContactDetail(params?.id || props.ids));
      // dispatch(fetchContactNotesList(params?.id || props.ids));
      // dispatch(fetchContactTasksList(params?.id || props.ids));
      // dispatch(fetchContactEmailList(params?.id || props.ids));
      // dispatch(fetchContactSmsList(params?.id || props.ids));
      dispatch(fetchContactfeedList(params?.id || props.ids));
      dispatch(fetchContactDeal(params?.id || props.ids));
      // dispatch(fetchContactRevertEmail(params?.id || props.ids));
    }
  }, [dispatch, params?.id, props?.ids]);

  const init = ["kt_quick_panelone"];

  useEffect(() => {
    initIds(init);
  }, [init]);

  return (
    <>
      <ContactDetailTop
        setActiveTab={setActiveTab}
        detail={contactDetail}
        setDealData={props?.setDealData}
        dealData={props?.dealData}
      />
      <div className="row mt-5">
        <div
          className={`col-md-12  ${
            props.type === "customer" ? "" : "col-lg-4"
          } contact-dtl gutter-c`}
        >
          <ContactUsers
            detailData={contactDetail}
            setOpenCanva={setOpenCanva}
          />
        </div>
        <div
          className={`col-md-12 ${
            props.type === "customer" ? "" : "col-lg-8"
          }  gutter-c mb-7`}
        >
          <ContactTabs
            ID={params?.id || props.ids}
            notesList={notesList}
            tasksList={tasksList}
            emailList={emailList}
            smsList={smsList}
            feedList={feedList}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            detailData={contactDetail}
            revertEmail={revertEmail}
            permission={permission}
            callId={params?.id || props.ids}
          />
        </div>
      </div>
      {openCanva ? (
        <>
          <CreateContactOffCanvas
            title={"Contact Details"}
            type={"edit"}
            contactDetail={contactDetail ? contactDetail : ""}
            setOpenCanva={setOpenCanva}
          />
          <div
            className="offcanvas-overlay"
            onClick={() => setOpenCanva(false)}
          ></div>
        </>
      ) : (
        ""
      )}
      <AddAttachment />

      <div className="order-2 order-xxl-1 ">
        <Card>
          <CardBody>
            <DealsTable checkbox={true} dealList={dealList} type="contact" />
          </CardBody>
        </Card>
      </div>
    </>
  );
};
